var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 36,
    viewBox: "0 0 76 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 36,
    fill: "#B80000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2113 27V10.248H13.8593V23.76H20.2433V27H10.2113ZM24.2898 27V24.096H26.4498V13.152H24.2898V10.248H32.2578V13.152H30.0978V24.096H32.2578V27H24.2898ZM41.1852 27L35.7852 10.248H39.4812L41.9772 18.288L43.2972 23.544H43.3692L44.6412 18.288L47.1372 10.248H50.7132L45.2652 27H41.1852ZM54.9066 27V10.248H66.3066V13.488H58.5546V16.92H65.2026V20.136H58.5546V23.76H66.3066V27H54.9066Z",
    fill: "#E9E9E9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/liveIcon.b100b6c2.svg";
export { ForwardRef as ReactComponent };